import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.control-object-identify-result-title {
	color: ${dt('controlObjectIdentify.resultTitle.color')};
	font-size: ${dt('controlObjectIdentify.resultTitle.fontSize')};
	line-height: ${dt('controlObjectIdentify.resultTitle.lineHeight')};
}

.control-object-identify-result-subtitle {
	color: ${dt('controlObjectIdentify.resultSubtitle.color')};
	font-size: ${dt('controlObjectIdentify.resultSubtitle.fontSize')};
}

.control-object-identify-unlinked-badge {
	background: ${dt('controlObjectIdentify.unlinkedBadge.background')};
	border-radius: ${dt('controlObjectIdentify.unlinkedBadge.borderRadius')};
}

.control-object-identify-unlinked-badge-icon {
	color: ${dt('controlObjectIdentify.unlinkedBadge.iconColor')};
	font-size: ${dt('controlObjectIdentify.unlinkedBadge.iconSize')};
}

.control-object-identify-empty-text {
	color: ${dt('controlObjectIdentify.emptyText.color')};
	font-size: ${dt('controlObjectIdentify.emptyText.fontSize')};
}

.control-object-identify-subject-row {
	border-bottom: 1px solid ${dt('controlObjectIdentify.subjectRow.borderColor')};
	transition: background-color 0.15s ease-in-out;
}

.control-object-identify-subject-row:last-child {
	border-bottom: none;
}

.control-object-identify-subject-name {
	color: ${dt('controlObjectIdentify.subjectRow.name.color')};
	font-size: ${dt('controlObjectIdentify.subjectRow.name.fontSize')};
	font-weight: ${dt('controlObjectIdentify.subjectRow.name.fontWeight')};
}

.control-object-identify-subject-address {
	color: ${dt('controlObjectIdentify.subjectRow.address.color')};
	font-size: ${dt('controlObjectIdentify.subjectRow.address.fontSize')};
}

.control-object-identify-link-row {
	border-top: 1px solid ${dt('controlObjectIdentify.subjectRow.borderColor')};
}

.control-object-identify-link-button {
	color: ${dt('controlObjectIdentify.linkButton.color')};
	font-size: ${dt('controlObjectIdentify.linkButton.fontSize')};
}
`;
